import { useNavigate } from "react-router-dom";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddPeoplePopup from "./AddPeoplePopup";

interface PeopleEmptyPageProps {
  onPeopleCreated?: (newPeople: any) => void;
}
export default function PeopleEmptyPage({ onPeopleCreated }: PeopleEmptyPageProps) {
  const navigate = useNavigate();

  return (
    <EntityEmptyPage
      title="People"
      colorKey="community"
      AddPopupComponent={AddPeoplePopup}
      onEntityCreated={onPeopleCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Person",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Person",
          openPopup: true,
        },
        {
          id: "bulkCreate",
          type: "button",
          label: "Import Bulk Data",
          onClick: () => { navigate('/community/people/import'); },
        },
      ]}
    />
  );
}

